import React from 'react';
import { Autocomplete, TextField, Checkbox } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import './multiSelect.css';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function MultiSelectCustom({
  options = [],
  value = [],
  onChange,
  label = '',
  placeholder = '',
  inputHeight = '53px',
  heightClass = '',
  error = false,
  helperText = '',
  disabled = false,
}) {
  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      options={options}
      getOptionLabel={(option) => option.label}
      value={options.filter(opt => value.includes(opt.value))}
      onChange={(event, newValue) => {
        onChange(newValue.map(item => item.value));
      }}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option.label}
        </li>
      )}
      renderTags={(selectedOptions) => {
        if (selectedOptions.length === 0) return null;
        const labels = selectedOptions.map(opt => opt.label).join(', ');
        return (
          <span
            className="comma-tags-ellipsis"
            title={labels} // show tooltip with full list
          >
            {selectedOptions.length === 1
              ? selectedOptions[0].label // show label if only 1 selected
              : `${selectedOptions.length} selected`}
          </span>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          variant="outlined"
          size="small"
          sx={{
            '& .MuiInputBase-root': {
              minHeight: inputHeight,
              borderRadius: '10px',
            }
          }}
        />
      )}
      disabled={disabled}
      className={`custom-multi-select ${heightClass}`}
    />
  );
}
